import src from "IMAGE";
export default { src, width: 671, height: 671, blurWidth: 0, blurHeight: 0};
